<template>
  <div id="app" :class="{ 'web-browser': auth.browser }">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <web-session-shell><keep-alive v-if="auth.browser && auth.session" :key="auth.session.username" include="WebHome"><router-view /></keep-alive><router-view v-else /></web-session-shell>
  </div>
</template>

<script>
import { webAuth } from './utils/web-auth'
import WebSessionShell from './components/WebSessionShell.vue'
export default { components: { WebSessionShell }, data() { return { auth: webAuth } } }
</script>

<style>
#app.web-browser { min-height: 100vh; min-height: 100dvh; background: #fff; }
/* Disable long-press text selection throughout the WebView. */
body {
  -webkit-user-select: none;
  user-select: none;
}

/* Keep selection and editing available in form fields and editable content. */
input,
textarea,
[contenteditable=""],
[contenteditable="true"],
[contenteditable="plaintext-only"] {
  -webkit-user-select: text;
  user-select: text;
}

/* App WebView: hide vertical scrollbars without changing scrolling or horizontal tables. */
*::-webkit-scrollbar {
  width: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */

body{
	margin:0;
	padding:0;
	border:0
}

</style>
